import React from "react";

export default () => {

    return <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16">
        <path d="M9.5,0,19,16H0Z" fill="#676767"/>
    </svg>;

}
